<template>
  <div>

    <div class="d-block d-sm-block d-md-none">
      <BannerTopMobile
        :image="`${url_banners_mobile}/images/mobile/banner_home.jpg`"
      ></BannerTopMobile>
    </div>

    <div class="container">
      <div class="text-center pb-10 d-none d-sm-block">
        <div style="position: relative; text-align:center">
          <span class="font-backward session_name_profile session_name font-weight-bold">
            ¡Hola {{ user.name }}!
          </span>
          <img class="img-session_name" src="@/assets/store/home/session_name.png" alt="">
        </div>
      </div>

      <div v-if="!order_selected">
        <div class="row mt-50">

          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 d-flex justify-content-center">
            <div class="w-90 color-blue font-general-r">
              <p class="h4 font-weight-bold">DETALLES DE LA CUENTA</p>
              <span class="h5">
                {{ user.name }} {{ user.lastname }}
              </span>
              <br> <br>
              <span v-if="user.primary_address" class="h5">
                {{ user.primary_address.full_address }}
              </span> <br>
              <span class="h5">
                {{ user.email }}
              </span> <br>
              <span class="h5">{{ user.phone }}</span> <br>
            </div>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 col-12 d-flex justify-content-center align-items-center">
            <div>
              <v-btn
                v-if="user.subscription"
                @click="modal_subscription = true"
                elevation="0"
                color="primary"
                class="nv-btn nv-btn-medium mb-5"
              >SUSCRIPCIÓN</v-btn> <br>
              <v-btn
                @click="modal_billing = true"
                elevation="0"
                color="primary"
                class="nv-btn nv-btn-medium mb-5"
              >SOLICITAR FACTURA</v-btn> <br>
              <v-btn
                elevation="0"
                color="primary"
                class="nv-btn nv-btn-medium"
                @click="editUser()"
              >EDITAR</v-btn> <br>
            </div>
          </div>

        </div>

        <v-row>
          <v-col cols="12">
            <v-card class="mt-5" color="primary" elevation="0">
              <v-card-title class="pb-0">
                <p class="h4 font-general-r color-blue">HISTORIAL DE PEDIDOS</p>
              </v-card-title>
              <v-card-text>
                <div v-if="orders.length" class="table-responsive-sm">
                  <table class="table">
                    <thead>
                      <tr>
                        <th class="color-blue font-general-r">PEDIDO</th>
                        <th class="color-blue font-general-r">FECHA</th>
                        <th class="color-blue font-general-r">TOTAL</th>
                        <th class="color-blue font-general-r">ESTADO DE PAGO</th>
                        <th class="color-blue font-general-r"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="order of orders" :key="order.id">
                        <td>
                          <v-btn
                            class="nv-btn"
                            :color="`${order_selected ? order_selected.id == order.id ? 'secondary' : 'primary' : 'primary'}`"
                            elevation="0"
                            @click="order_selected = order"
                          >
                            #{{ order.code }}
                          </v-btn>
                        </td>
                        <td class="td-nv">
                          <p class="h5 mt-2">
                            {{ formatDate(order.created_at, 'D MMMM YYYY') }}
                          </p>
                        </td>
                        <td class="td-nv">
                          <p class="h5 mt-2">
                            {{ currencyFormat(order.total) }}
                          </p>
                        </td>
                        <td class="td-nv">
                          <p class="h5 mt-2">
                            {{ getPaymentStatus(order.payment_status).text }}
                          </p>
                        </td>
                        <td class="color-secondary">
                          <p class="h5 mt-2">{{ getStatus(order.status).text }}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <p v-else class="h3 text-center font-general-r color-blue">
                  No tienes pedidos
                </p>

                <div v-if="orders.length" class="text-center">
                  <v-pagination
                    color="secondary"
                    v-model="page"
                    circle
                    :length="total_pages"
                  ></v-pagination>
                </div>

              </v-card-text>
              <v-overlay :value="loading_orders" :absolute="true">
                <v-progress-circular
                  indeterminate
                  size="50"
                ></v-progress-circular>
              </v-overlay>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div v-if="order_selected">

        <v-row>
          <v-col class="d-flex justify-content-center" cols="12" xl="6" lg="6" md="6" sm="12">
            <div class="w-90 color-blue font-general-r">
              <p class="h4">DIRECCIÓN DE ENVÍO</p>
              <span class="h5">
                Estado del pago: {{ order_selected.payment_status ? 'PAGADO' : 'PENDIENTE' }}
              </span> <br> <br>
              <span class="h5">
                {{ order_selected.address.name }}
                {{ order_selected.address.lastname }}
              </span> <br>
              <span class="h5">
                {{ order_selected.address.full_address }}
              </span> <br>
              <span class="h5">
                {{ order_selected.address.email }}
              </span>
              <span class="h5">
                {{ order_selected.address.phone }}
              </span>
            </div>
          </v-col>
          <v-col class="d-flex justify-content-center align-items-end" cols="12" xl="6" lg="6" md="6" sm="12">
            <v-btn
              @click="order_selected = null"
              elevation="0"
              color="primary"
              class="nv-btn nv-btn-medium mb-5"
            >VOLVER</v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card class="mt-5 m-auto" color="primary" elevation="0" max-width="850">
              <v-card-title class="pb-0">
                <p class="h4 font-general-r color-blue">
                  PEDIDO #{{ order_selected.code }}
                </p>
              </v-card-title>
              <v-card-title class="pb-0">
                <p class="h4 font-general-r color-blue">
                  Realizado el {{ formatDate(order_selected.created_at, 'D MMMM YYYY') }}
                </p>
              </v-card-title>
              <v-card-text>
                <div class="table-responsive-sm">
                  <table class="table">
                    <thead>
                      <tr>
                        <th class="color-blue font-general-r">PRODUCTO</th>
                        <th class="color-blue font-general-r">PRECIO</th>
                        <th class="color-blue font-general-r">CANTIDAD</th>
                        <th class="color-blue font-general-r">TOTAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item of order_selected.details" :key="item.id">
                        <td class="td-nv">
                          <p class="h5 mt-2">{{ item.product }}</p>
                          <span class="h5 mt-2">{{ item.variant }}</span>
                        </td>
                        <td class="td-nv">
                          <p class="h5 mt-2">
                            {{ currencyFormat(item.price) }}
                          </p>
                        </td>
                        <td class="td-nv">
                          <p class="h5 mt-2">
                            {{ item.quantity }}
                          </p>
                        </td>
                        <td class="color-secondary">
                          <p class="h5 mt-2">
                            {{ currencyFormat(item.subtotal) }}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="border-nv mb-10 mt-10"></div>
                  <div class="d-flex justify-space-between color-blue font-general-r">
                    <p class="h5 mt-2">SUBTOTAL</p>
                    <p class="h5 mt-2">{{ currencyFormat(order_selected.subtotal) }}</p>
                  </div>
                  <div class="d-flex justify-space-between color-blue font-general-r">
                    <p class="h5 mt-2">ENVÍO</p>
                    <p class="h5 mt-2">{{ currencyFormat(order_selected.shipping_amount) }}</p>
                  </div>
                  <div class="d-flex justify-space-between color-blue font-general-r mt-5">
                    <p class="h5 mt-2 font-weight-bold">TOTAL</p>
                    <p class="h5 mt-2 font-weight-bold">{{ currencyFormat(order_selected.total) }}</p>
                  </div>
                </div>

              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

    </div>

    <!--modal editar datos personales-->
    <v-dialog
      v-model="modal_edit_user"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card color="light">
        <v-toolbar
          color="light"
          elevation="0"
        >
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="closeModalEditUser"
            class="mr-2"
          >
            <v-icon large color="accent">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <div class="row mb-5">
          <div class="col text-center">
            <div style="position: relative">
              <span class="font-backward session_name_profile session_name font-weight-bold">
                ¡Hola {{ user.name }}!
              </span>
              <img class="img-session_name" src="@/assets/store/home/session_name.png" alt="">
            </div>
          </div>
        </div>

        <EditProfile @closeModal="closeModalEditUser" :user_edit="user_edit"></EditProfile>

      </v-card>
    </v-dialog>

    <!--modal detalle suscripcion-->
    <v-dialog
      v-model="modal_subscription"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      color="light"
    >
      <v-card color="light">
        <v-toolbar
          color="light"
          elevation="0"
        >
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="modal_subscription = false"
            class="mr-2"
          >
            <v-icon large color="accent">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <div class="row mb-5">
          <div class="col text-center">
            <div style="position: relative">
              <span class="font-backward session_name_profile font-weight-bold">
                SUSCRIPCIÓN
              </span>
              <img class="img-session_name" src="@/assets/store/home/session_name.png" alt="">
            </div>
          </div>
        </div>

        <div v-if="subscription" class="container">
          <div v-if="!show_edit_address_subscription" class="text-center">
            <img class="img-detail-subscription" :src="subscription.product.url_image" alt="">
          </div>

          <div class="row mt-5">
            <div class="col">
              <div class="subscription-detail color-blue">
                <h2 class="font-backward text-center font-weight-bold mb-5">
                  {{ subscription.product.name }}
                </h2>

                <div class="m-auto subscription-flavors font-general-r">
                  <div class="d-flex flex-wrap">
                    <p class="mr-1">SABORES:</p>
                    <p v-for="(item, i) of subscription.flavors" :key="i" class="mr-1">
                      {{ item.flavor_name }}{{ i != subscription.flavors.length - 1 ? ',' : '' }}
                    </p>
                  </div>

                  <div class="d-flex justify-space-between flex-wrap mb-1">
                    <p>{{ subscription.type.name }}</p>
                    <p>{{ currencyFormat(subscription.product.price) }}</p>
                  </div>

                  <div class="mb-5 div-border-payment p-1 font-general-r">
                    <div class="d-flex align-items-center justify-content-between flex-wrap">
                      <span class="ml-2">Enviar a</span>
                      <span class="color-primary">
                        {{ subscription.address.full_address }}
                      </span>
                      <v-btn
                        @click="editAddressSubscription()"
                        small
                        class="nv-btn-small"
                        text
                        elevation="0"
                        color="accent"
                      >
                        {{ show_edit_address_subscription ? 'Cancelar' : 'Cambiar' }}
                      </v-btn>
                    </div>
                  </div>

                  <transition name="fade">
                    <edit-address-subscription
                      v-if="show_edit_address_subscription"
                      :subscription_id="subscription.id"
                      @addressChanged="addressChangedSubscription"
                    />
                  </transition>

                  <template v-if="!show_edit_address_subscription">
                    <p>MÉTODO DE PAGO</p>
                    <div class="mb-10 div-border-payment p-1 font-general-r">
                      <div class="d-flex align-items-center justify-content-between flex-wrap">
                        <span class="ml-2">
                          Tarjeta *** *** *** {{ user.card_last_four }}
                        </span>
                      </div>
                    </div>

                    <div class="center-content-sm">
                      <p>
                        PAGOS
                      </p>

                      <p>
                        Tu siguiente pago es de: {{ currencyFormat(subscription.product.price) }}
                      </p>

                      <v-btn @click="open_payments_subscription = true" style="padding: 0 !important" class="font-weight-bold" text color="primary">
                        Ver historial de pagos
                      </v-btn>
                      <PaymentsSubscription
                        v-if="open_payments_subscription"
                        :payments="subscription.payments"
                        @closePayments="open_payments_subscription = false"
                      />
                    </div>

                    <div class="container-buttons-detail-subscription mt-50 mb-50">
                      <v-btn @click="modal_cancel_subscription = true" elevation="0" color="primary" class="nv-btn nv-btn-large mb-2">
                        CANCELAR SUSCRIPCIÓN
                      </v-btn>
                      <v-btn
                        @click="editSubscription()"
                        elevation="0"
                        color="primary"
                        class="nv-btn nv-btn-large"
                        v-if="subscription.stripe_status != 'incomplete'"
                      >
                        EDITAR ITACATE
                      </v-btn>
                    </div>
                  </template>

                </div>

              </div>
            </div>
          </div>

        </div>
      </v-card>
    </v-dialog>

    <!--modal cancelar suscripcion-->
    <v-dialog
      v-model="modal_cancel_subscription"
      width="800"
      hide-overlay
    >
      <v-card class="color-blue font-general-r">
        <v-card-title style="padding: 10px 0 10px 0">
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="modal_cancel_subscription = false"
          >
            <v-icon color="accent">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <div class="color-blue font-general-r text-center px-5">
          <h5>¡Te vamos a extrañar, esperamos volverte a ver pronto!</h5>
        </div>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="nv-btn nv-btn-large"
            elevation="0"
            @click="cancelSubscription()"
            :loading="loading_btn_cancel_subscription"
          >
            CANCELAR SUSCRIPCIÓN
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--modal success cancel suscripcion-->
    <v-dialog
      v-model="modal_success_cancel"
      persistent
      max-width="690"
      hide-overlay
    >
      <v-card class="pa-2">
        <v-card-text>

          <div class="d-flex justify-content-center align-items-center mt-10 color-blue font-general-r">
            <img class="bolsa-popups d-none d-sm-none d-md-block" src="@/assets/store/iconos/bolsa.svg" alt="">
            <div class="ml-5 text-center">
              <h5>Tu suscripción ha sido cancelada exitosamente</h5>
            </div>
          </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            elevation="0"
            class="nv-btn"
            @click="modal_success_cancel = false"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--modal success edit suscripcion-->
    <v-dialog
      v-model="modal_success_edit_subscription"
      persistent
      max-width="690"
      hide-overlay
    >
      <v-card class="pa-2">
        <v-card-text>

          <div class="d-flex justify-content-center align-items-center mt-10 color-blue font-general-r">
            <img class="bolsa-popups d-none d-sm-none d-md-block" src="@/assets/store/iconos/bolsa.svg" alt="">
            <div class="ml-5 text-center">
              <h5>Tu suscripción ha sido modificada exitosamente</h5>
            </div>
          </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="nv-btn"
            elevation="0"
            @click="modal_success_edit_subscription = false"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--modal editar suscripcion-->
    <div
      v-if="modal_edit_subscription"
      class="v-dialog__content v-dialog__content--active"
      style="z-index: 2001 !important"
    >
      <div
        class="v-dialog v-dialog--active v-dialog--fullscreen"
        style="transform-origin: center center;"
      >
        <v-card color="light" v-if="subscription">
          <v-toolbar
            color="light"
            elevation="0"
          >
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="modal_edit_subscription = false"
              class="mr-2"
            >
              <v-icon large color="accent">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <EditSubscription @successEdit="successEditSubscription" :copy_subscription="copy_subscription"/>

        </v-card>
      </div>
    </div>

    <!--modal facturar-->
    <v-dialog
      v-model="modal_billing"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card color="light">
        <v-toolbar
          color="light"
          elevation="0"
        >
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="modal_billing = false"
            class="mr-2"
          >
            <v-icon large color="accent">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <BillingRequest @cancel="cancelBillingRequest"/>

      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
      <img class="nv-loading" src="@/assets/store/nievedeolla.gif" alt="">
    </v-overlay>

  </div>
</template>

<script>
import { currencyFormat } from '@/helpers'
import { mapState } from 'vuex'
import UserService from '@/services/user.service'
import EditSubscription from '@/components/store/EditSubscription'
import BillingRequest from '@/components/store/BillingRequest'
import EditProfile from '@/components/store/EditProfile'
import moment from 'moment'
moment.locale('es')
import PaymentsSubscription from '@/components/store/PaymentsSubscription'
import EditAddressSubscription from '@/components/store/EditAddressSubscription'

export default {
  components: { EditSubscription, BillingRequest, EditProfile, PaymentsSubscription, EditAddressSubscription },
  data() {
    return {
      open_payments_subscription: false,
      url_banners_mobile: process.env.VUE_APP_URL_FILES,
      loading_edit_user: false,
      order_selected: null,
      loading_orders: false,
      subscription: null,
      copy_subscription: null,
      overlay: false,
      modal_subscription: false,
      modal_cancel_subscription: false,
      modal_success_edit_subscription: false,
      modal_edit_user: false,
      modal_success_cancel: false,
      loading_btn_cancel_subscription: false,
      modal_edit_subscription: false,
      loading_btn_edit_subscription: false,
      modal_billing: false,
      orders: [],
      page: 1,
      total_pages: 1,
      user_edit: {
        name: '',
        lastname: '',
        email: '',
        phone: ''
      },
      show_edit_address_subscription: false,
      option_temporada: {id: 'temporada', flavor_id: 'temporada', flavor_name: 'SABOR DE TEMPORADA', remove: true}
    }
  },
  computed: {
    ...mapState(['user', 'is_auth'])
  },
  watch: {
    page(newval) {
      this.getOrders(newval)
    }
  },
  methods: {
    getPaymentStatus(status) {
			if (['1', 'approved', 'succeeded'].includes(status)) {
				return { color: 'success', text: 'Pagado' }
			} else {
				return { color: 'warning', text: 'Pago pendiente' }
			}
		},
    addressChangedSubscription(data) {
      this.subscription.address = data.address
      this.show_edit_address_subscription = false
    },
    editAddressSubscription() {
      this.show_edit_address_subscription = !this.show_edit_address_subscription
    },
    closeModalEditUser() {
      this.modal_edit_user = false
      this.user_edit = JSON.parse(JSON.stringify(this.$options.data().user_edit))
    },
    editUser() {
      this.user_edit = {...this.user}
      this.modal_edit_user = true
    },
    getStatus(status) {
			if (status == 1) return { text: 'SIN PREPARAR', color: 'accent'}
			if (status == 2) return { text: 'EN PREPARACIÓN', color: 'warning'}
      if (status == 3) return { text: 'PREPARADO', color: 'success'}
      if (status == 4) return { text: 'ENVIADO', color: 'success'}
      if (status == 5) return { text: 'ENTREGADO', color: 'success'}
			if (status == 6) return { text: 'CANCELADO', color: 'error'}
		},
    formatDate(date, format) {
			return moment(date).format(format)
		},
    cancelBillingRequest() {
      this.modal_billing = false
    },
    editSubscription() {
      console.log('asd')
      this.loading_btn_edit_subscription = true
      this.getSubscription()
      this.loading_btn_edit_subscription = false
      this.modal_edit_subscription = true
    },
    successEditSubscription() {
      this.getSubscription()
      this.modal_subscription = false
      this.modal_edit_subscription = false
      setTimeout(() => {
        this.modal_success_edit_subscription = true
      }, 500)
    },
    async cancelSubscription() {
      try {
        this.loading_btn_cancel_subscription = true
        const { data:res } = await UserService.cancelSubscription()
        if (res.success) {
          this.$store.dispatch('setUser', res.data.user)
          this.subscription = null
          this.modal_success_cancel = true
          this.modal_cancel_subscription = false
          this.modal_subscription = false
        } else {
          this.$swal(res.error, '', 'warning')
        }
      } catch (error) {
        this.$swal('En estos momentos no podemos procesar tu solicitud', '', 'warning')
      }
      this.loading_btn_cancel_subscription = true
    },
    async getSubscription() {
      const { data:res } = await UserService.getActiveSubscription()
      if (Object.keys(res).length) {
        this.subscription = res

        this.subscription.flavors_ids = this.subscription.flavors.map(i => {
          return i.flavor_id
        })

        this.copy_subscription = JSON.parse(JSON.stringify(this.subscription))
      } else {
        this.subscription = null
      }
    },
    async getOrders(page = 1) {
      this.loading_orders = true
      const { data:res } = await UserService.getOrders(page)
      if (res.data.length) {
        this.orders = res.data
        this.total_pages = res.last_page
      }
      this.loading_orders = false
    },
    currencyFormat(price) {
			return currencyFormat(price)
    }
  },
  mounted() {
    this.overlay = true
    setTimeout(() => {
      this.overlay = false
    }, 1000)
    this.getSubscription()
    this.getOrders()
  }
}
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  >>>.v-sheet.v-card {
    border-radius: 0px;
  }
  table {
    border-collapse: collapse;
  }
  th, tr {
    border: none !important;
  }
  .table th, .td-nv {
    font-size: 18px;
    text-align: left;
    color: var(--color-tertiary);
    font-family: var(--font-baloo-regular)
  }
  >>>.v-pagination {
    font-family: var(--font-baloo-regular)
  }
  >>>.table td, .table th {
    border-top: 0 !important
  }
  >>>.v-pagination__item {
    border-radius: 0;
  }
  >>>.v-pagination__item:focus {
    outline: none;
  }
  >>>.nv-btn:hover {
    background-color: var(--color-secondary) !important;
  }
  >>>.vbga-results {
    background-color: #14365b;
    color: #ffffff;
    list-style: none;
    padding-left: 0;
    z-index: 1000000 !important;
    font-family: var(--font-baloo-regular);
    border-radius: 10px;
    position: relative
  }
  >>>.vbga-results li {
    padding: 5px;
  }
  >>>.vbga-results li:hover {
    cursor: pointer;
    background-color: #ed717c;
  }
</style>
